<section class="wishlist-detail-side-panels" aria-label="Informacje dodatkowe">
  @for (panel of panels(); track panel.title) {
    <ui-disclosure-panel
      [title]="panel.title"
      [hint]="panel.hint"
      [open]="panel.defaultOpen"
    >
      @if (
        panel.progressValue !== null &&
        panel.progressMax !== null &&
        panel.progressLabel !== null
      ) {
        <wishlist-progress-summary
          [label]="panel.progressLabel"
          [value]="panel.progressValue"
          [max]="panel.progressMax"
        />
      }

      @if (panel.rows.length > 0) {
        <dl class="wishlist-detail-side-panels__rows">
          @for (row of panel.rows; track row.label) {
            <div class="wishlist-detail-side-panels__row">
              <dt>{{ row.label }}</dt>
              <dd
                [class.wishlist-detail-side-panels__row-value--success]="
                  row.tone === 'success'
                "
                [class.wishlist-detail-side-panels__row-value--warning]="
                  row.tone === 'warning'
                "
                [class.wishlist-detail-side-panels__row-value--danger]="
                  row.tone === 'danger'
                "
              >
                {{ row.value }}
              </dd>
            </div>
          }
        </dl>
      }

      @if (panel.bodyLines.length > 0) {
        <div class="wishlist-detail-side-panels__copy">
          @for (line of panel.bodyLines; track line) {
            <p>{{ line }}</p>
          }
        </div>
      }
    </ui-disclosure-panel>
  }
</section>
